import { Text } from '@stereograph/teia-system-design/components/Typography';
import { usePluginTranslation } from '@translation';

export const TeiaQuantityTakeoffTableColumnError = () => {
  const { t } = usePluginTranslation();

  return (
    <Text sx={{
      p: 2,
    }}
    >
      {t('quantity_takeoff_plugin.column_error.label')}
    </Text>
  );
};
